// v10/src/services/componentLifespanService.js
//
// Servicios de Vida límite por aeronave (A6.1). Wrapper del axios `api`
// que ya maneja JWT, refresh automático e impersonación de SuperAdmin.
//
// Tarea 1: solo se consumen `getCatalog`, `getComponents` y `getDashboard`.
// El resto queda definido para que la Tarea 2 (modales, reemplazos, attachments) los use.

import api from './apiService';

const componentLifespanService = {
  // ── Catálogo (lectura libre, global sin organization_id) ─────────
  getCatalog:     (params = {}) => api.get('/api/component-catalog', { params }),
  getCatalogItem: (id)          => api.get(`/api/component-catalog/${id}`),

  // ── Componentes por aeronave ─────────────────────────────────────
  getComponents:   (params = {}) => api.get('/api/aircraft-components', { params }),
  getComponent:    (id)          => api.get(`/api/aircraft-components/${id}`),
  createComponent: (data)        => api.post('/api/aircraft-components', data),
  updateComponent: (id, data)    => api.put(`/api/aircraft-components/${id}`, data),
  deleteComponent: (id)          => api.delete(`/api/aircraft-components/${id}`),

  // ── Vista global y dashboard ─────────────────────────────────────
  getGlobalAttention: (params = {}) => api.get('/api/aircraft-components/global-attention', { params }),
  getDashboard:       ()            => api.get('/api/aircraft-components/dashboard'),

  // ── Reemplazos (los usa la Tarea 2) ──────────────────────────────
  getReplacements:    (componentId)       => api.get(`/api/aircraft-components/${componentId}/replacements`),
  createReplacement:  (componentId, data) => api.post(`/api/aircraft-components/${componentId}/replacements`, data),

  // ── Attachments del 337 (los usa la Tarea 2) ─────────────────────
  uploadAttachment: (componentId, data) => api.post(`/api/aircraft-components/${componentId}/attachment`, data),
  deleteAttachment: (componentId)       => api.delete(`/api/aircraft-components/${componentId}/attachment`),
  uploadReplacementAttachment: (componentId, replacementId, data) =>
    api.post(`/api/aircraft-components/${componentId}/replacements/${replacementId}/attachment`, data),
  deleteReplacementAttachment: (componentId, replacementId) =>
    api.delete(`/api/aircraft-components/${componentId}/replacements/${replacementId}/attachment`),
};

export default componentLifespanService;
